import { useEffect, useRef, useState } from "react";
import { siteData } from "@/store/siteData";
import { useImageUrl } from "@/hooks/useImageUrl";

function TestimonialImage({ item }: { item: ReturnType<typeof siteData.getTestimonials>[0] }) {
  const imgUrl = useImageUrl(item.imageId, item.imageUrl);
  return <img src={imgUrl} alt={item.name} className="w-full h-full object-cover object-top transition-opacity duration-500" />;
}

export default function TestimonialSection() {
  const [visible, setVisible] = useState(false);
  const [active, setActive] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const testimonials = siteData.getTestimonials();

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setVisible(true); }, { threshold: 0.15 });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  if (!testimonials.length) return null;
  const t = testimonials[Math.min(active, testimonials.length - 1)];

  return (
    <section ref={ref} data-edit="testimonials" className="bg-[#E8EBF4] py-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className={`grid grid-cols-1 lg:grid-cols-5 gap-0 border border-[#C8CEDF] transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-3 p-10 lg:p-14 flex flex-col justify-between bg-[#EEF0F8]">
            <div>
              <div className="flex items-center gap-3 mb-8">
                <div className="h-px w-12 bg-[#3B82F6]"></div>
                <span className="text-[#64748B] text-xs font-semibold tracking-[0.3em] uppercase">Referanslarımız</span>
              </div>
              <p className="text-[#111928] leading-relaxed font-medium mb-8" style={{ fontSize: "clamp(18px, 2.2vw, 26px)", lineHeight: "1.6" }}>
                <span className="font-black" style={{ fontSize: "4rem", lineHeight: "0.5", verticalAlign: "-.4em", color: "#334155" }}>&ldquo;</span>
                {t.quote}
              </p>
              <div className="flex items-center gap-4">
                <div>
                  <p className="text-[#111928] font-bold text-base">{t.name}</p>
                  <p className="text-[#64748B] text-sm">{t.title}</p>
                  <p className="text-[#64748B] text-xs mt-0.5">{t.company}</p>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-10">
              {testimonials.map((_, i) => (
                <button key={i} onClick={() => setActive(i)} className={`transition-all duration-300 cursor-pointer ${active === i ? "w-8 h-0.5 bg-[#3B82F6]" : "w-4 h-0.5 bg-[#334155] hover:bg-[#64748B]"}`} aria-label={`Referans ${i + 1}`} />
              ))}
            </div>
          </div>
          <div className="lg:col-span-2 relative min-h-64 lg:min-h-0 overflow-hidden bg-[#FFFFFF]">
            <TestimonialImage item={t} />
            <div className="absolute inset-0 bg-gradient-to-t from-[#F1F5F9]/60 to-transparent lg:bg-gradient-to-r lg:from-[#F1F5F9]/30 lg:to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
